<div>
	<ng-content></ng-content>
	<hr style="height: 1px; opacity: 25%" class="mt-1 mb-2" />
</div>
